// Privana-authored presentation only; tenant content and evidence remain verbatim.
export default {
  "copy": {
    "selectAnActiveFrameworkVersion": "Select an Active framework version.",
    "thisFrameworkIsNotApplicableToThisClub": "This framework is not applicable to this club.",
    "selectACompletedAssessmentFromTheSameFramework": "Select a completed assessment from the same framework.",
    "aCompletedPriorAssessmentIsRequired": "A completed prior assessment is required.",
    "selectAnActiveMemberOfThisClubSStaff": "Select an active member of this club’s staff.",
    "startTheAssessmentBeforeEvaluatingControls": "Start the assessment before evaluating controls.",
    "completedAndCancelledAssessmentsAreImmutable": "Completed and cancelled assessments are immutable.",
    "selectAValidAssessmentResult": "Select a valid assessment result.",
    "addAMeaningfulNarrativeForThisResult": "Add a meaningful narrative for this result.",
    "evaluateEveryControlBeforeCompletingTheAssessment": "Evaluate every control before completing the assessment.",
    "youDoNotHavePermissionToPerformThisOperation": "You do not have permission to perform this operation.",
    "theAssessmentWasNotFoundForThisClub": "The assessment was not found for this club.",
    "anActiveFindingAlreadyExistsForThisAssessmentResult": "An active Finding already exists for this assessment result.",
    "onlyPartiallyCompliantOrNonCompliantResultsCanBecomeFindings": "Only Partially Compliant or Non-Compliant results can become Findings.",
    "selectLowMediumHighOrCritical": "Select Low, Medium, High or Critical.",
    "enterAFindingTitle": "Enter a Finding title.",
    "describeTheComplianceDeficiency": "Describe the compliance deficiency.",
    "theAssessmentOperationCouldNotBeCompleted": "The assessment operation could not be completed.",
    "assessments": "Assessments",
    "evaluateEveryCanonicalControlInAnActiveFrameworkVersion": "Evaluate every canonical control in an active framework version.",
    "newAssessment": "New Assessment",
    "searchAssessments": "Search assessments",
    "searchAssessments2": "Search assessments…",
    "status": "Status",
    "framework": "Framework",
    "assessmentType": "Assessment type",
    "all": "All",
    "loadingAssessments": "Loading assessments…",
    "noAssessmentsYet": "No assessments yet",
    "assessmentsEvaluateYourClubAgainstTheControlsInAnActiveComplianceFramework": "Assessments evaluate your club against the controls in an active compliance framework.",
    "createAssessment": "Create Assessment",
    "assessment": "Assessment",
    "version": "Version",
    "type": "Type",
    "owner": "Owner",
    "progress": "Progress",
    "started": "Started",
    "completed": "Completed",
    "updated": "Updated",
    "evaluated": " evaluated",
    "selectActiveFrameworkVersion": "Select active framework version",
    "controls": "controls",
    "assessmentTitle": "Assessment title",
    "defaultToMe": "Default to me",
    "loadingCompletedAssessments": "Loading completed assessments…",
    "selectCompletedPriorAssessment": "Select completed prior assessment",
    "completed2": "· Completed",
    "noCompletedAssessmentsAreAvailableForReassessmentAgainstThisFramework": "No completed assessments are available for reassessment against this framework.",
    "createDraftAssessment": "Create Draft Assessment",
    "unassigned": "Unassigned",
    "created": "Created",
    "complete": "% complete",
    "startAssessment": "Start Assessment",
    "completeAssessment": "Complete Assessment",
    "cancel": "Cancel",
    "searchControls": "Search controls…",
    "category": "Category",
    "result": "Result",
    "importance": "Importance",
    "controlVersion": "· Control version {version}",
    "requirement": "Requirement",
    "guidance": "Guidance",
    "applicabilityGuidance": "Applicability guidance",
    "evaluationMethod": "Evaluation method",
    "evidenceMethod": "Evidence method",
    "reviewFrequency": "Review frequency",
    "currentAssessmentResult": "Current assessment result",
    "assessmentNarrative": "Assessment narrative",
    "saveEvaluation": "Save Evaluation",
    "finding": "Finding",
    "raiseFinding": "Raise Finding",
    "title": "Title",
    "description": "Description",
    "severity": "Severity",
    "onlyCompletedAssessmentsCanBeUsedForAnAuditPack": "Only completed assessments can be used for an Audit Pack.",
    "thisAuditPackCouldNotBeFound": "This Audit Pack could not be found.",
    "thisAuditPackCanNoLongerBeChanged": "This Audit Pack can no longer be changed.",
    "thisAuditPackIsAlreadyBeingGenerated": "This Audit Pack is already being generated.",
    "generationOwnershipChangedRefreshAndTryAgain": "Generation ownership changed. Refresh and try again.",
    "tooManyCurrentEvidenceDocumentsAreInScope": "Too many current Evidence documents are in scope.",
    "theEvidencePackageIsTooLargeToGenerateSafely": "The Evidence package is too large to generate safely.",
    "aCurrentEvidenceDocumentCouldNotBeRetrievedNoIncompletePackageWasGenerated": "A current Evidence document could not be retrieved. No incomplete package was generated.",
    "enterARationaleBeforeVoidingThisAuditPack": "Enter a rationale before voiding this Audit Pack.",
    "unableToCompleteTheAuditPackOperation": "Unable to complete the Audit Pack operation.",
    "loadingAssuranceOverview": "Loading assurance overview…",
    "setUpYourComplianceProgramme": "Set up your Compliance programme",
    "privanaCanHelpYouBuildAStructuredAssuranceProgrammeForYourClub": "Privana can help you build a structured assurance programme for your club.",
    "chooseAFramework": "Choose a Framework",
    "startWithAPrivanaTemplateOrCreateYourOwn": "Start with a Privana template or create your own.",
    "reviewYourControls": "Review your Controls",
    "tailorTheSuggestedRequirementsToYourClub": "Tailor the suggested requirements to your club.",
    "runYourFirstAssessment": "Run your first Assessment",
    "establishYourCurrentCompliancePosition": "Establish your current compliance position.",
    "step": "Step",
    "setUpCompliance": "Set up Compliance",
    "overallCompliance": "Overall Compliance",
    "notAssessed": "Not assessed",
    "openFindings": "Open Findings",
    "actionsDue": "Actions Due",
    "auditReadiness": "Audit Readiness",
    "notEnoughData": "Not enough data",
    "assuranceReadinessIndicatorNotCertification": "Assurance-readiness indicator, not certification",
    "executiveAssurance": "Executive assurance",
    "currentAssurancePostureFromCanonicalComplianceRecords": "Current assurance posture from canonical Compliance records.",
    "readinessDimensions": "Readiness dimensions",
    "notMeasurable": "Not measurable",
    "recentComplianceActivity": "Recent Compliance activity",
    "timesShownIn": "Times shown in",
    "auditPacks": "Audit Packs",
    "immutableVersionedAssuranceSnapshotsForFormalReview": "Immutable, versioned assurance snapshots for formal review.",
    "newAuditPack": "New Audit Pack",
    "searchAuditPacks": "Search audit packs",
    "searchPacks": "Search packs…",
    "statusFilter": "Status filter",
    "allStatuses": "All statuses",
    "draft": "Draft",
    "generating": "Generating",
    "generated": "Generated",
    "void": "Void",
    "noAuditPacks": "No audit packs",
    "createAPackFromACompletedAssessment": "Create a pack from a completed assessment.",
    "pack": "Pack",
    "generatedBy": "Generated By",
    "documents": "Documents",
    "selectCompletedAssessment": "Select completed assessment…",
    "includeEvidenceDocuments": "Include Evidence Documents",
    "createDraft": "Create Draft",
    "noDescriptionProvided": "No description provided.",
    "generateAuditPack": "Generate Audit Pack",
    "generatingAuditPack": "Generating Audit Pack…",
    "theImmutableReportAndAuthorisedEvidencePackageAreBeingPreparedRefreshToCheckItsStatus": "The immutable report and authorised Evidence package are being prepared. Refresh to check its status.",
    "manifestV": "Manifest v",
    "downloadPDF": "Download PDF",
    "downloadEvidencePackage": "Download Evidence Package",
    "voidAuditPack": "Void Audit Pack",
    "voidingIsTerminalExplainWhyThisDraftMustNotBeGenerated": "Voiding is terminal. Explain why this Draft must not be generated.",
    "voidRationale": "Void rationale",
    "voidRationale2": "Void rationale…",
    "actionDue": "Action due",
    "safetyReview": "Safety review",
    "complianceDate": "Compliance date",
    "owner2": "Owner:",
    "priority": "priority",
    "overdue": "Overdue",
    "open": "Open",
    "youDoNotHaveAccessToTheComplianceCalendar": "You do not have access to the Compliance Calendar.",
    "theComplianceCalendarCouldNotBeLoaded": "The Compliance Calendar could not be loaded.",
    "complianceCalendar": "Compliance Calendar",
    "dueThisWeek": "Due this week",
    "next30Days": "Next 30 days",
    "safetyReviewsDue": "Safety reviews due",
    "previousMonth": "Previous month",
    "today": "Today",
    "nextMonth": "Next month",
    "calendarView": "Calendar view",
    "calendar": "Calendar",
    "agenda": "Agenda",
    "filters": "Filters",
    "eventCategory": "Event category",
    "allEvents": "All events",
    "actions": "Actions",
    "frameworks": "Frameworks",
    "safetyReviews": "Safety Reviews",
    "timing": "Timing",
    "allDates": "All dates",
    "upcoming": "Upcoming",
    "loadingComplianceDates": "Loading compliance dates",
    "loadingComplianceDates2": "Loading compliance dates…",
    "sun": "Sun",
    "mon": "Mon",
    "tue": "Tue",
    "wed": "Wed",
    "thu": "Thu",
    "fri": "Fri",
    "sat": "Sat",
    "more": "more",
    "selectedDayAgenda": "Selected day agenda",
    "noComplianceItemsForThisDay": "No compliance items for this day.",
    "noComplianceDatesInThisPeriod": "No compliance dates in this period",
    "today2": " · Today",
    "date": "Date",
    "andTime": " and time",
    "sourceReference": "Source reference",
    "context": "Context",
    "priority2": "Priority",
    "close": "Close",
    "thatKeyAndVersionAlreadyExists": "That key and version already exists.",
    "activeAndRetiredControlsCannotBeEditedCreateANewVersionInstead": "Active and retired controls cannot be edited. Create a new version instead.",
    "onlyDraftFrameworkVersionsCanHaveTheirControlsChanged": "Only Draft framework versions can have their controls changed.",
    "activateEveryAttachedControlBeforeActivatingThisVersion": "Activate every attached control before activating this version.",
    "onlyActiveControlsCanBeAssignedToAFrameworkVersion": "Only Active controls can be assigned to a framework version.",
    "controlOrderingMustUseNonNegativeWholeNumbers": "Control ordering must use non-negative whole numbers.",
    "eachAssignedControlMustHaveAUniqueOrder": "Each assigned control must have a unique order.",
    "thisFrameworkAlreadyHasAnActiveVersionSupersedeOrRetireItExplicitlyFirst": "This framework already has an Active version. Supersede or retire it explicitly first.",
    "aRationaleIsRequiredWhenAFrameworkIsNotApplicable": "A rationale is required when a framework is Not Applicable.",
    "theEffectiveToDateMustBeOnOrAfterEffectiveFrom": "The effective-to date must be on or after effective-from.",
    "youDoNotHaveComplianceEditPermission": "You do not have Compliance edit permission.",
    "attachAtLeastOneActiveControlBeforeActivation": "Attach at least one Active control before activation.",
    "createAFrameworkVersionBeforeActivatingThisFramework": "Create a framework version before activating this framework.",
    "thisLifecycleActionIsNotValidForTheCurrentStatus": "This lifecycle action is not valid for the current status.",
    "theComplianceOperationCouldNotBeCompleted": "The Compliance operation could not be completed.",
    "no": "No",
    "yet": " yet",
    "controlsDefineTheRequirementsUsedByComplianceFrameworksAndAssessments": "Controls define the requirements used by Compliance frameworks and assessments.",
    "frameworksOrganiseReusableControlsIntoADefinedComplianceProgramme": "Frameworks organise reusable controls into a defined compliance programme.",
    "create": "Create",
    "control": "Control",
    "privanaWillGenerateTheControlReferenceAutomatically": "Privana will generate the Control reference automatically.",
    "controlDefinition": "Control definition",
    "assuranceSettings": "Assurance settings",
    "controlLibrary": "Control Library",
    "reusableVersionedRequirementsForYourComplianceProgrammes": "Reusable, versioned requirements for your compliance programmes.",
    "browsePrivanaLibrary": "Browse Privana Library",
    "newControl": "New Control",
    "searchControls2": "Search controls",
    "allCategories": "All categories",
    "allImportance": "All importance",
    "loadingControls": "Loading controls…",
    "evaluation": "Evaluation",
    "evidence": "Evidence",
    "createControl": "Create Control",
    "frameworkReferences": "Framework references",
    "edit": "Edit",
    "activate": "Activate",
    "createNewVersion": "Create New Version",
    "retire": "Retire",
    "editDraftControl": "Edit Draft Control",
    "saveChanges": "Save Changes",
    "createNewControlVersion": "Create New Control Version",
    "createDraftVersion": "Create Draft Version",
    "availableControls": "Available Controls",
    "available": "available",
    "searchAvailableControls": "Search available controls",
    "searchActiveControls": "Search Active Controls…",
    "availableControlCategory": "Available Control category",
    "availableControlImportance": "Available Control importance",
    "version2": "· Version",
    "add": "Add",
    "allMatchingControlsAreAlreadyAssigned": "All matching Controls are already assigned.",
    "assignedControls": "Assigned Controls",
    "assigned": "assigned",
    "searchAssignedControls": "Search assigned controls",
    "searchAssignedControls2": "Search assigned Controls…",
    "frameworkReferenceFor": "Framework reference for",
    "frameworkReferenceOptional": "Framework reference (optional)",
    "moveUp": "Move Up",
    "moveDown": "Move Down",
    "removeControl": "Remove Control",
    "noAssignedControlsMatchThisSearch": "No assigned Controls match this search.",
    "controlsAssigned": "Controls assigned",
    "privanaComplianceLibrary": "Privana Compliance Library",
    "loadingPrivanaTemplates": "Loading Privana templates…",
    "privanaLibraryIsTemporarilyUnavailableYouCanStillBuildACustomFramework": "Privana Library is temporarily unavailable. You can still build a custom Framework.",
    "privanaTemplatesAreGuidanceAndShouldBeTailoredWithAppropriateProfessionalAdvice": "Privana templates are guidance and should be tailored with appropriate professional advice.",
    "chooseTheSuggestedControlsToCopyIntoYourDraftProgrammeYouCanReviewAndTailorThemBeforeActivation": "Choose the suggested Controls to copy into your Draft programme. You can review and tailor them before activation.",
    "selectAll": "Select all",
    "clearAll": "Clear all",
    "suggestedEvidence": "· Suggested Evidence:",
    "reviewDuringTailoring": "Review during tailoring",
    "privanaTemplatesProvideAStructuredStartingPointForYourClubSAssuranceProgrammeReviewAndTailorEachProgrammeToYourOrganisationJurisdictionInsurerAndProfessionalAdviceBeforeActivation": "Privana templates provide a structured starting point for your club's assurance programme. Review and tailor each programme to your organisation, jurisdiction, insurer and professional advice before activation.",
    "searchTemplates": "Search templates",
    "searchTemplates2": "Search templates…",
    "templateCategory": "Template category",
    "recommended": "Recommended",
    "privanaTemplate": "Privana template ·",
    "controls2": "Controls",
    "preview": "Preview",
    "useThisTemplate": "Use this template",
    "backToTemplates": "Back to templates",
    "selected": "selected",
    "creatingDraft": "Creating Draft…",
    "adoptDraftControls": "Adopt Draft Controls",
    "createDraftFramework": "Create Draft Framework",
    "frameworkRetiredSuccessfully": "Framework retired successfully.",
    "notConfigured": "Not configured",
    "createAndManageVersionedComplianceProgrammes": "Create and manage versioned compliance programmes.",
    "newFramework": "New Framework",
    "searchFrameworks": "Search frameworks",
    "searchFrameworks2": "Search frameworks…",
    "frameworkStatus": "Framework status",
    "loadingFrameworks": "Loading frameworks…",
    "chooseHowYourClubWantsToEstablishItsAssuranceProgramme": "Choose how your club wants to establish its assurance programme.",
    "startFromPrivanaLibrary": "Start from Privana Library",
    "chooseACuratedAssuranceProgrammeAndTailorTheSuggestedControls": "Choose a curated assurance programme and tailor the suggested Controls.",
    "buildACustomFramework": "Build a Custom Framework",
    "createAProgrammeFromScratchForAClubSpecificOrExternalRequirement": "Create a programme from scratch for a club-specific or external requirement.",
    "currentVersion": "Current version",
    "versions": "Versions",
    "applicability": "Applicability",
    "notSet": "Not set",
    "createFrameworkAndFirstDraftVersion": "Create Framework and First Draft Version",
    "privanaWillGenerateTheFrameworkReferenceAndInitialVersionAutomatically": "Privana will generate the Framework reference and initial version automatically.",
    "name": "Name",
    "versionTitle": "Version title",
    "effectiveFrom": "Effective from",
    "effectiveTo": "Effective to",
    "createdFromPrivanaComplianceLibrary": "Created from Privana Compliance Library",
    "versionStatus": "Version status",
    "activeControls": "Active Controls",
    "awaitingReview": "Awaiting review",
    "reviewAndActivateAllAttachedControlsFirst": "Review and activate all attached Controls first.",
    "activateVersion": "Activate Version",
    "manageControls": "Manage Controls",
    "editApplicability": "Edit Applicability",
    "setApplicability": "Set Applicability",
    "newVersion": "New Version",
    "moreVersionActions": "More version actions",
    "supersedeVersion": "Supersede Version",
    "markThisVersionAsHistorical": "Mark this version as historical",
    "retireVersion": "Retire Version",
    "removeFromFutureActiveUse": "Remove from future active use",
    "deEmphasisedDuringInitialSetup": "De-emphasised during initial setup",
    "activateFramework": "Activate Framework",
    "moreFrameworkActions": "More framework actions",
    "retireFramework": "Retire Framework",
    "removeFromFutureAssuranceUse": "Remove from future assurance use",
    "versionHistory": "Version history",
    "noStartDate": "No start date",
    "openEnded": "Open ended",
    "selectedVersionWorkspace": "Selected version workspace",
    "reviewSuggestedControls": "Review suggested Controls",
    "controlsReviewed": "Controls reviewed",
    "reviewed": "reviewed",
    "anAuthorizedControlsEditorMustReviewAndActivateTheseControls": "An authorized Controls editor must review and activate these Controls.",
    "reviewControls": "Review Controls",
    "readyToActivateVersion": "Ready to activate version",
    "total": "Total",
    "active": "Active",
    "awaitingReview2": "Awaiting Review",
    "retired": "Retired",
    "searchControls3": "Search Controls",
    "searchControls4": "Search Controls…",
    "controlStatusFilter": "Control status filter",
    "controlCategoryFilter": "Control category filter",
    "frameworkOrder": "Framework order",
    "uncategorised": "Uncategorised",
    "noReference": "No reference",
    "noControlsMatchTheseFilters": "No Controls match these filters.",
    "createDraftFrameworkVersion": "Create Draft Framework Version",
    "copyControlsFromVersion": "Copy controls from version",
    "doNotCopyControls": "Do not copy controls",
    "searchSuggestedControls": "Search suggested Controls",
    "reviewCategoryFilter": "Review category filter",
    "reviewImportanceFilter": "Review importance filter",
    "reviewStatusFilter": "Review status filter",
    "selectAllDraft": "Select all Draft",
    "clearSelection": "Clear selection",
    "evidence2": "· Evidence:",
    "noRequirementSummary": "No requirement summary.",
    "openControl": "Open Control",
    "activateSelectedControls": "Activate selected Controls",
    "controlsEditPermissionRequired": "Controls edit permission required",
    "chooseWhichActiveControlsBelongToThisDraftFrameworkVersionAndArrangeHowTheyAppearWithinTheProgramme": "Choose which Active Controls belong to this Draft Framework Version and arrange how they appear within the programme.",
    "controlAssignmentsSaved": "Control assignments saved.",
    "discardUnsavedChanges": "Discard unsaved changes?",
    "yourStagedControlMembershipChangesWillNotBeSaved": "Your staged Control membership changes will not be saved.",
    "keepEditing": "Keep Editing",
    "discardChanges": "Discard Changes",
    "frameworkApplicability": "Framework Applicability",
    "doesThisProgrammeApplyToYourClub": "Does this programme apply to your club?",
    "recordWhetherThisFrameworkVersionAppliesToTheClubAndWhereUsefulTheReasonAndApplicablePeriod": "Record whether this Framework Version applies to the club and, where useful, the reason and applicable period.",
    "applicable": "Applicable",
    "underReview": "Under Review",
    "notApplicable": "Not Applicable",
    "reasonThisDoesNotApply": "Reason this does not apply",
    "reviewNotes": "Review notes",
    "applicableFrom": "Applicable from",
    "applicableTo": "Applicable to",
    "theseOptionalDatesDefineThePeriodForWhichThisApplicabilityDecisionApplies": "These optional dates define the period for which this applicability decision applies.",
    "saveApplicability": "Save Applicability",
    "retireFramework2": "Retire Framework?",
    "retiringThisFrameworkRemovesItFromFutureActiveAssuranceUseWhilePreservingItsVersionsAssessmentsFindingsActionsEvidenceAndAuditHistory": "Retiring this Framework removes it from future active assurance use while preserving its versions, assessments, findings, actions, evidence and audit history.",
    "retirementRationale": "Retirement rationale",
    "programmeRetiredFollowingReplacementByAConsolidatedAssuranceFramework": "Programme retired following replacement by a consolidated assurance framework.",
    "supersedeFrameworkVersion": "Supersede Framework Version?",
    "retireFrameworkVersion": "Retire Framework Version?",
    "supersedingThisVersionMarksItAsHistoricalAndPreventsItFromBeingTreatedAsTheCurrentActiveVersionExistingAssessmentsFindingsActionsEvidenceAndAuditHistoryRemainUnchanged": "Superseding this version marks it as historical and prevents it from being treated as the current active version. Existing assessments, findings, actions, evidence and audit history remain unchanged.",
    "retiringThisVersionRemovesItFromFutureActiveUseWhilePreservingItsHistoricalAssessmentsEvidenceAndAuditRecord": "Retiring this version removes it from future active use while preserving its historical assessments, evidence and audit record.",
    "supersedeRationale": "Supersede rationale",
    "replacedByThe2027AssuranceBaseline": "Replaced by the 2027 assurance baseline.",
    "evidenceWorkspaces": "Evidence workspaces",
    "evidenceRegister": "Evidence Register",
    "insuranceIntelligence": "Insurance Intelligence",
    "unableToLoadEvidence": "Unable to load Evidence.",
    "evidenceWasNotFound": "Evidence was not found.",
    "unableToCreateEvidence": "Unable to create Evidence.",
    "uploadAGenuinePDFPNGOrJPEGDocument": "Upload a genuine PDF, PNG or JPEG document.",
    "filesMustBe20MBOrSmaller": "Files must be 20 MB or smaller.",
    "documentUploadFailedPleaseTryAgain": "Document upload failed. Please try again.",
    "thePrivateDocumentCouldNotBeOpened": "The private document could not be opened.",
    "unableToUpdateEvidence": "Unable to update Evidence.",
    "thatLifecycleTransitionIsNotAllowed": "That lifecycle transition is not allowed.",
    "unableToLinkEvidence": "Unable to link Evidence.",
    "canonicalAssuranceRecordsSupportingYourComplianceProgramme": "Canonical assurance records supporting your Compliance programme.",
    "addEvidence": "Add Evidence",
    "activeEvidence": "Active Evidence",
    "uploadedDocuments": "Uploaded Documents",
    "manualEvidence": "Manual Evidence",
    "unlinkedEvidence": "Unlinked Evidence",
    "searchEvidence": "Search evidence",
    "allSourceTypes": "All source types",
    "manual": "Manual",
    "uploadedDocument": "Uploaded Document",
    "allLinkedStates": "All linked states",
    "linked": "Linked",
    "unlinked": "Unlinked",
    "noEvidenceYet": "No evidence yet",
    "evidenceProvidesTheRecordsDocumentsAndAssuranceMaterialThatSupportYourComplianceControlsAssessmentsFindingsAndRemediation": "Evidence provides the records, documents and assurance material that support your Compliance controls, assessments, findings and remediation.",
    "captured": "Captured",
    "links": "Links",
    "createdBy": "Created By",
    "previous": "Previous",
    "page": "Page",
    "records": "records",
    "next": "Next",
    "recordAnAttestationOrOtherManuallyCapturedAssuranceItem": "Record an attestation or other manually captured assurance item.",
    "uploadDocument": "Upload Document",
    "securelyAttachAPrivatePDFOrImageDocument": "Securely attach a private PDF or image document.",
    "changeEvidenceType": "← Change evidence type",
    "optionalSourceReference": "Optional Source Reference",
    "capturedAt": "Captured At",
    "file": "File",
    "pDFPNGOrJPEGMaximum20MB": "PDF, PNG or JPEG · maximum 20 MB",
    "sourceManualStatusActive": "Source: Manual · Status: Active",
    "uploading": "Uploading…",
    "createEvidence": "Create Evidence",
    "sourceType": "Source Type",
    "sourceSystem": "Source System",
    "sourceReference2": "Source Reference",
    "createdAt": "Created At",
    "updatedAt": "Updated At",
    "lifecycleReason": "Lifecycle reason",
    "sizeUnavailable": "Size unavailable",
    "viewDownload": "View / Download",
    "noDescription": "No description.",
    "editMetadata": "Edit metadata",
    "supersede": "Supersede",
    "withdraw": "Withdraw",
    "saveMetadata": "Save metadata",
    "linkedTo": "Linked To",
    "unlinkEvidence": "Unlink evidence",
    "selectTarget": "Select target",
    "linkEvidence": "Link Evidence",
    "insuranceAnalysisComplete": "Insurance analysis complete",
    "viewInsights": "View Insights",
    "viewInsuranceIntelligence": "View Insurance Intelligence",
    "needsClubReview": "Needs club review",
    "needsReview": "Needs review",
    "theInsurancePolicySetCouldNotBeLoaded": "The Insurance Policy Set could not be loaded.",
    "liveProgressConnectionWasInterruptedYourAnalysisIsStillRunning": "Live progress connection was interrupted. Your analysis is still running.",
    "viewComplianceImpact": "View Compliance impact",
    "continueReview": "Continue review",
    "reviewRecommendations": "Review recommendations",
    "uploadFailed": "Upload failed",
    "uploadAtLeastOneValidPDFBeforeAnalysis": "Upload at least one valid PDF before analysis.",
    "analysisCouldNotBeStarted": "Analysis could not be started.",
    "thisRecommendationHasAlreadyBeenReviewed": "This recommendation has already been reviewed.",
    "weCouldnTSaveThisDecisionPleaseTryAgain": "We couldn't save this decision. Please try again.",
    "frameworkVersionsCouldNotBeLoaded": "Framework Versions could not be loaded.",
    "reviewTheHighlightedControlFieldsBeforeCreatingIt": "Review the highlighted Control fields before creating it.",
    "anotherAdoptionIsAlreadyInProgressPleaseRefreshInAMoment": "Another adoption is already in progress. Please refresh in a moment.",
    "theSelectedFrameworkVersionIsNoLongerEditable": "The selected Framework Version is no longer editable.",
    "thisControlAlreadyExistsInYourClub": "This Control already exists in your club.",
    "weCouldnTAddThisLibraryControlPleaseTryAgain": "We couldn't add this Library Control. Please try again.",
    "weCouldnTCreateThisDraftControlPleaseTryAgain": "We couldn't create this Draft Control. Please try again.",
    "thisControlMustBeActiveBeforeItCanBeAddedToTheFramework": "This Control must be Active before it can be added to the Framework.",
    "weCouldnTCancelThisFrameworkIntentionPleaseTryAgain": "We couldn't cancel this Framework intention. Please try again.",
    "thisOutlookReminderAlreadyExists": "This Outlook reminder already exists.",
    "outlookReminderCreated": "Outlook reminder created.",
    "calendarPermissionIsNeededConnectOutlookCalendarWithoutChangingYourMailConnection": "Calendar permission is needed. Connect Outlook Calendar without changing your mail connection.",
    "theOutlookReminderCouldNotBeCreated": "The Outlook reminder could not be created.",
    "loadingInsurancePolicy": "Loading Insurance Policy…",
    "insuranceIntelligence2": "← Insurance Intelligence",
    "insuranceIntelligence3": "Insurance Intelligence ·",
    "reviewComplete": "Review complete",
    "reviewInProgress": "Review in progress",
    "analysisComplete": "Analysis complete",
    "preparingAnalysis": "Preparing analysis",
    "reanalyse": "Reanalyse",
    "insurer": "Insurer",
    "policyNumber": "Policy number",
    "policyPeriod": "Policy period",
    "primaryLimit": "Primary limit",
    "excess": "Excess",
    "underwriter": "Underwriter",
    "analysing": "Analysing",
    "of": "of",
    "pagesProcessed": "pages processed",
    "yourPreviousCompletedAnalysisRemainsAvailableWhileThisAnalysisRuns": "Your previous completed analysis remains available while this analysis runs.",
    "analysisCouldNotBeCompleted": "Analysis could not be completed",
    "yourDocumentsAndAnyPreviousCompletedAnalysisAreSafePleaseTryAgain": "Your documents and any previous completed analysis are safe. Please try again.",
    "retryAnalysis": "Retry analysis",
    "importantForYourAttention": "Important for your attention",
    "whyThisMatters": "Why this matters",
    "page2": "· page",
    "viewSource": "· View Source",
    "policyReview": "Policy review",
    "privanaFoundRecommendationsFromThisPolicyReviewThemBeforeAnythingChangesInCompliance": "Privana found recommendations from this policy. Review them before anything changes in Compliance.",
    "reviewed2": "reviewed ·",
    "remaining": "remaining",
    "existingMatches": "existing matches ·",
    "suggestedControls": "suggested Controls ·",
    "dates": "dates ·",
    "needsReview2": "needs review",
    "existingControlsMatched": "existing Controls matched",
    "privanaFoundControlsThatMayAlreadyAddressPolicyRequirements": "Privana found Controls that may already address policy requirements.",
    "suggestedControls2": "suggested Controls",
    "requirementsThatMayNeedAnAdditionalControlOrClubReview": "Requirements that may need an additional Control or club review.",
    "importantDates": "important dates",
    "policyDatesAndPreparationMilestonesIdentified": "Policy dates and preparation milestones identified.",
    "review": "Review",
    "matches": "Matches",
    "suggestedControls3": "Suggested Controls",
    "dates2": "Dates",
    "reviewFilter": "Review filter",
    "whatThePolicyRequires": "What the policy requires",
    "policyRequirement": "Policy requirement",
    "privanaSRecommendedMatch": "Privana’s recommended match",
    "privanaSSuggestedControl": "Privana’s suggested Control",
    "draftARepeatablePolicyComplianceControl": "Draft a repeatable policy compliance Control",
    "status2": "Status:",
    "frameworks2": "Frameworks:",
    "none": "None",
    "latestAssessment": "Latest assessment:",
    "notAssessed2": "not assessed",
    "evidence3": "Evidence:",
    "supported": "Supported",
    "noCurrentSupport": "No current support",
    "strongMatch": "Strong match",
    "possibleMatch": "Possible match",
    "whyPrivanaRecommendsIt": "Why Privana recommends it",
    "libraryProvenance": "Library provenance:",
    "version3": "· version",
    "addedToFramework": "Added to Framework",
    "readyToAddToFramework": "Ready to add to Framework",
    "waitingForControlActivation": "Waiting for Control activation",
    "matchConfirmed": "Match confirmed",
    "notAMatch": "Not a match",
    "dismissed": "Dismissed",
    "libraryControlAdded": "Library Control added",
    "draftControlCreated": "Draft Control created",
    "recommendationReviewed": "Recommendation reviewed",
    "target": "Target:",
    "viewControl": "View Control",
    "adding": "Adding…",
    "cancelling": "Cancelling…",
    "cancelFrameworkIntention": "Cancel Framework intention",
    "viewFramework": "View Framework",
    "saving": "Saving…",
    "confirmMatch": "Confirm match",
    "markForReview": "Mark for review",
    "addToMyControls": "Add to my Controls",
    "createDraftControl": "Create Draft Control",
    "frameworkEditAccessIsRequired": "Framework edit access is required",
    "addToFramework": "Add to Framework",
    "createAddToFramework": "Create & Add to Framework",
    "controlsEditAccessIsRequiredToAdoptThisRecommendation": "Controls edit access is required to adopt this recommendation.",
    "dismiss": "Dismiss",
    "youReAllCaughtUpInThisSection": "You’re all caught up in this section.",
    "viewCompleted": "View completed",
    "privanaDerivedMilestone": "Privana-derived milestone",
    "policyDeadline": "Policy deadline",
    "policyPeriodDate": "Policy period date",
    "suggestedMilestoneDerivedFromPolicyInformationNotAContractualCondition": "Suggested milestone derived from policy information — not a contractual condition.",
    "viewInComplianceCalendar": "View in Compliance Calendar",
    "addToOutlook": "Add to Outlook",
    "viewSource2": "View Source",
    "policyRequirements": "Policy requirements",
    "extractedClausesRemainAvailableGroupedForEasierReview": "extracted clauses remain available, grouped for easier review.",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "confidencePage": "% confidence · page",
    "privanaSInterpretation": "Privana’s interpretation",
    "sourceDocuments": "Source documents",
    "originalDocumentsUsedForThisAnalysis": "Original documents used for this analysis.",
    "addPDFs": "Add PDFs",
    "pages": "pages ·",
    "view": "View",
    "removeDocument": "Remove document",
    "analysePolicy": "Analyse Policy",
    "privanaLibraryControl": "Privana Library Control",
    "suggestedControl": "Suggested Control",
    "reviewThisReadOnlyLibraryControlBeforeAddingItToYourProgramme": "Review this read-only Library Control before adding it to your programme.",
    "reviewPrivanaSRecommendationBeforeAddingItToYourComplianceProgramme": "Review Privana’s recommendation before adding it to your Compliance programme.",
    "destination": "Destination",
    "chooseTheFrameworkDestinationPrivanaWillRememberItWhileYouReviewAndActivateTheDraftControl": "Choose the Framework destination. Privana will remember it while you review and activate the Draft Control.",
    "targetFrameworkVersion": "Target Framework Version",
    "chooseAFrameworkVersion": "Choose a Framework Version",
    "evaluation2": "Evaluation:",
    "source": "Source",
    "privanaLibrary": "Privana Library ·",
    "libraryControlTemporarilyUnavailable": "Library Control temporarily unavailable",
    "privanaCannotSafelyLoadThisHistoricalLibraryControlRightNowNoGeneratedControlWillBeSubstituted": "Privana cannot safely load this historical Library Control right now. No generated Control will be substituted.",
    "creating": "Creating…",
    "createDraftControlContinue": "Create Draft Control & Continue",
    "analysisHistory": "Analysis history",
    "pages2": "pages",
    "privanaProvidesPolicyInterpretationAndAssuranceSupportNotLegalCertificationReviewMaterialInsuranceMattersWithYourBrokerInsurerOrProfessionalAdviser": "Privana provides policy interpretation and assurance support, not legal certification. Review material insurance matters with your broker, insurer or professional adviser.",
    "insuranceIntelligenceCouldNotBeLoaded": "Insurance Intelligence could not be loaded.",
    "thePolicySetCouldNotBeCreated": "The policy set could not be created.",
    "turnComplexInsuranceWordingIntoClearObligationsAssuranceGapsAndActionsForYourClub": "Turn complex insurance wording into clear obligations, assurance gaps and actions for your club.",
    "uploadInsurancePolicy": "Upload Insurance Policy",
    "privanaUsesAIToIdentifyAndOrganizePotentiallyImportantPolicyWordingReviewMaterialCoverageAndContractualQuestionsWithYourBrokerInsurerOrProfessionalAdviserWhereAppropriate": "Privana uses AI to identify and organize potentially important policy wording. Review material coverage and contractual questions with your broker, insurer or professional adviser where appropriate.",
    "policyTitle": "Policy title",
    "insuranceType": "Insurance type",
    "insurerOptional": "Insurer (optional)",
    "policyNumberOptional": "Policy number (optional)",
    "createThePolicySetFirstThenSecurelyAddUpTo10PrivatePDFs100MBAnd1500PagesEachClassifyEachScheduleWordingOrEndorsementAndStartDurableAnalysis": "Create the policy set first, then securely add up to 10 private PDFs (100 MB and 1,500 pages each), classify each schedule, wording or endorsement, and start durable analysis.",
    "createPolicySet": "Create Policy Set",
    "completedSafetyChecklists": "Completed Safety Checklists",
    "riskAssessments": "Risk Assessments",
    "alertEvents": "Alert Events",
    "theSourceProvidesSupportingAssuranceForTheControl": "The source provides supporting assurance for the Control.",
    "theSourceMayDemonstrateThatTheControlIsNotBeingSatisfied": "The source may demonstrate that the Control is not being satisfied.",
    "theSourceDemonstratesCorrectiveRemediationActivity": "The source demonstrates corrective/remediation activity.",
    "theSourceIndependentlyVerifiesTheControlCondition": "The source independently verifies the Control condition.",
    "thisNativeEvidenceSourceIsNotSupported": "This native Evidence source is not supported.",
    "thatSourceCapabilityIsNotAvailable": "That source capability is not available.",
    "selectAValidActiveControl": "Select a valid Active Control.",
    "theRequestedMappingOrControlIsNoLongerAvailable": "The requested mapping or Control is no longer available.",
    "mappingsCanOnlyTargetActiveControls": "Mappings can only target Active Controls.",
    "selectAValidEvidenceRelationship": "Select a valid Evidence relationship.",
    "recordsConsideredPerSyncMustBeAWholeNumberFrom1To250": "Records considered per sync must be a whole number from 1 to 250.",
    "theSourceConfigurationIsTooLarge": "The source configuration is too large.",
    "thisSourceIsAlreadyMappedToThatControl": "This source is already mapped to that Control.",
    "providerSourceCapabilityAndControlCannotBeChanged": "Provider, source capability, and Control cannot be changed.",
    "youDoNotHavePermissionToChangeIntegrations": "You do not have permission to change Integrations.",
    "theIntegrationsOperationCouldNotBeCompleted": "The Integrations operation could not be completed.",
    "never": "Never",
    "editMapping": "Edit mapping",
    "addMapping": "Add mapping",
    "sourceCapability": "Source Capability",
    "activeControl": "Active Control",
    "searchKeyOrTitle": "Search key or title…",
    "selectAnActiveControl": "Select an Active Control",
    "relationship": "Relationship",
    "recordsConsideredPerSync": "Records considered per sync",
    "limitsHowManyRecentSourceRecordsPrivanaReviewsDuringEachSync": "Limits how many recent source records Privana reviews during each sync.",
    "enabled": "Enabled",
    "saveMapping": "Save Mapping",
    "mappings": "mappings",
    "mapNativeSourceCapabilitiesToActiveControlsDisablingAMappingOnlyAffectsFutureSyncsHistoricalEvidenceRemainsUnchanged": "Map native source capabilities to Active Controls. Disabling a mapping only affects future syncs; historical Evidence remains unchanged.",
    "noSupportedSourceCapabilitiesAreCurrentlyAvailableForThisClub": "No supported source capabilities are currently available for this club.",
    "addMapping2": "Add Mapping",
    "noMappingsConfigured": "No mappings configured.",
    "configuration": "Configuration",
    "disabled": "Disabled",
    "latest": "Latest",
    "disable": "Disable",
    "enable": "Enable",
    "syncCouldNotBeCompletedPleaseTryAgain": "Sync could not be completed. Please try again.",
    "loadingNativeIntegrations": "Loading native integrations…",
    "nativeEvidenceIntegrations": "Native Evidence Integrations",
    "configureAndOperateTrustedPrivanaSourcesThatProduceComplianceEvidence": "Configure and operate trusted Privana sources that produce Compliance Evidence.",
    "addIntegration": "Add Integration",
    "addAnIntegration": "Add an Integration",
    "discoverTrustedEvidenceSourcesForYourAssuranceProgramme": "Discover trusted Evidence sources for your assurance programme.",
    "useCompletedSafetyChecksAndRiskAssessmentsAsTrustedComplianceEvidence": "Use completed safety checks and risk assessments as trusted Compliance Evidence.",
    "native": "Native",
    "comingSoon": "Coming soon",
    "bringIdentityMFAPrivilegedAccessAndSecurityAssuranceSignalsIntoPrivanaCompliance": "Bring identity, MFA, privileged-access and security assurance signals into Privana Compliance.",
    "moreComingSoon": "More coming soon!",
    "privanaIsContinuallyExpandingTheSystemsThatCanContributeTrustedComplianceEvidence": "Privana is continually expanding the systems that can contribute trusted Compliance Evidence.",
    "nATIVE": "NATIVE",
    "configured": "Configured",
    "readyToConfigure": "Ready to configure",
    "available2": "Available",
    "unavailable": "Unavailable",
    "enabledMappings": "Enabled mappings",
    "evidenceProduced": "Evidence produced",
    "lastOutcome": "Last outcome",
    "completedWithErrors": "Completed with errors",
    "successful": "Successful",
    "notSynced": "Not synced",
    "sourceCapabilities": "Source capabilities",
    "lastSync": "Last sync",
    "viewEvidence": "View Evidence",
    "syncing": "Syncing…",
    "syncNow": "Sync Now",
    "syncComplete": "Sync complete",
    "integrationUnavailable": "Integration unavailable",
    "thisProviderIsNotCurrentlyAvailableForYourClubRefreshThePageOrContactAnAdministrator": "This provider is not currently available for your club. Refresh the page or contact an administrator.",
    "search": "Search…",
    "remediationActions": "remediation actions",
    "actionsTrackTheWorkRequiredToRemediateComplianceFindings": "Actions track the work required to remediate compliance findings.",
    "findingsTrackComplianceGapsIdentifiedThroughAssessmentsAndAssuranceReviews": "Findings track compliance gaps identified through assessments and assurance reviews.",
    "raiseFindingsFromEligibleAssessmentResults": "Raise findings from eligible assessment results.",
    "completionSummary": "Completion summary",
    "blockedReason": "Blocked reason",
    "cancellationRationale": "Cancellation rationale",
    "action": "Action",
    "due": "Due",
    "overdue2": " · Overdue",
    "start": "Start",
    "block": "Block",
    "complete2": "Complete",
    "resume": "Resume",
    "unableToLoadFindings": "Unable to load findings.",
    "closureSummary": "Closure summary",
    "complianceFindings": "Compliance Findings",
    "formalDeficienciesAndExceptionsRaisedFromCanonicalAssessmentResults": "Formal deficiencies and exceptions raised from canonical assessment results.",
    "openFindings2": "Open findings",
    "readyForReview": "Ready for review",
    "overdueActions": "Overdue actions",
    "findingStatus": "Finding status",
    "findingSeverity": "Finding severity",
    "allSeverities": "All severities",
    "overdue3": "overdue",
    "assessmentResult": "Assessment result",
    "closed": "Closed",
    "remediationActions2": "Remediation Actions",
    "actionTitle": "Action title",
    "selectActionOwner": "Select action owner",
    "addAction": "Add Action",
    "noRemediationActionsYet": "No remediation actions yet.",
    "theDailyWorkQueueForResolvingComplianceFindings": "The daily work queue for resolving compliance findings.",
    "actionStatus": "Action status",
    "allPriorities": "All priorities",
    "dueState": "Due state",
    "allDueDates": "All due dates",
    "dueSoon": "Due Soon",
    "noDueDate": "No Due Date",
    "unknownFailure": "The Compliance operation could not be completed.",
    "noControls": "No controls yet",
    "noFrameworks": "No frameworks yet",
    "noActions": "No remediation actions yet",
    "noFindings": "No findings yet",
    "evaluatedCount": "{evaluated} / {total} evaluated",
    "completionPercent": "{percent} complete",
    "assessmentIncomplete": "This assessment cannot be completed yet. {count} controls remain unevaluated{references}.",
    "allStatus": "All statuses",
    "allFrameworks": "All frameworks",
    "allAssessmentTypes": "All assessment types",
    "allResults": "All results",
    "stepNumber": "Step {step}",
    "assessedScope": "{assessed} of {total} current framework versions assessed · {controls} applicable controls",
    "findingSeverityCounts": "{critical} critical · {high} high",
    "dueCounts": "Due in 30 days · {overdue} overdue",
    "timesIn": "Times shown in {timezone}",
    "selectDate": "Select {date}",
    "ownerName": "Owner: {owner}",
    "priorityLevel": "{priority} priority",
    "moreCount": "+{count} more",
    "openTarget": "Open {target}",
    "dateTime": "Date and time",
    "orderNumber": "Order {order}",
    "referenceFor": "Framework reference for {control}",
    "reorderControl": "Reorder or remove {control}",
    "previewName": "Preview · {name}",
    "versionSuccess": "Version {status} successfully.",
    "versionNumber": "Version {version}",
    "suggestedReviewCounts": "{total} suggested Controls · {approved} approved · {awaiting} awaiting review",
    "readyActiveCounts": "{active} / {total} Active · Ready to activate version",
    "reviewedControls": "{reviewed} of {total} Controls reviewed",
    "selectControl": "Select {control}",
    "activatedControls": "{count} Controls activated.",
    "evidenceTransition": "Why is this evidence being {status}?",
    "analysingPolicy": "Analysing {title} · {percent}",
    "documentsCountOne": "{count} document",
    "documentsCountOther": "{count} documents",
    "reviewCount": "To review {count}",
    "completedCount": "Completed {count}",
    "addToFrameworkName": "Add to {name}",
    "importanceLevel": "{importance} importance",
    "providerUnavailable": "{provider} capability is not available for this club.",
    "providerMappings": "{provider} mappings",
    "elementDescription": "Use monitored alert events and physical-world exceptions as trusted Compliance Evidence.",
    "mappingView": "View Mappings",
    "mappingManage": "Manage Mappings",
    "configure": "Configure",
    "syncNeedsMapping": "Add at least one enabled mapping before syncing.",
    "syncNeedsAvailable": "Enable a mapping for an available source capability before syncing.",
    "overdueCount": "{count} overdue",
    "insuranceQueued": "Queued",
    "insurancePreparingdocuments": "Preparing documents",
    "insuranceReadingpolicy": "Reading policy",
    "insuranceIdentifyingrequirements": "Identifying requirements",
    "insuranceCheckingyourCompliancecontrols": "Checking your Compliance controls",
    "insurancePreparingrecommendations": "Preparing recommendations",
    "insuranceFinalisinganalysis": "Finalising analysis",
    "insuranceAnalysisfailed": "Analysis failed",
    "insuranceExclusions": "Exclusions",
    "insuranceConditionsofcover": "Conditions of cover",
    "insuranceRecommendations": "Recommendations",
    "insuranceDefinitionspolicyinformation": "Definitions & policy information",
    "insuranceClaimsnotification": "Claims & notification",
    "insuranceDataprotectionprivacy": "Data protection & privacy",
    "insuranceIncidentresponse": "Incident response",
    "insuranceOperationalresilience": "Operational resilience",
    "insuranceSecurityrequirements": "Security requirements",
    "insuranceGovernancepeople": "Governance & people",
    "insuranceOtherpolicywording": "Other policy wording",
    "evidenceMethodSummary": " · Evidence: {method}",
    "diagnostic": "{message} (Code: {code}; Request: {request})",
    "nativeChecklist": "Safety checklist: {title}",
    "nativeRisk": "Risk assessment: {title}",
    "nativeElement": "Element alert: {title}",
    "nativeResult": "Completed with result {result}.",
    "nativeRiskDescription": "Risk score {score}; status {status}.",
    "controlCount": "{count} Controls",
    "continue": "Continue",
    "messageControls": "{value1} ({value2}) · {value3} · {value4} controls",
    "messageCompleted2": "{value1} · {value2} · Completed {value3}",
    "messageCreated": "Created {value1}",
    "messageEvaluated": "{value1} / {value2}  evaluated",
    "messageControlVersion": "{value1} · {value2} · Control version {value3}",
    "messageFinding": "Finding {value1} · {value2}",
    "messageTimesShownIn": "Times shown in {value1}",
    "messageManifestV": "Manifest v{value1} · SHA-256 {value2}",
    "messageTimesShownIn2": "Times shown in {value1}",
    "messageMore": "+{value1} more",
    "messageAvailable": "{value1} available",
    "messageVersion2": "{value1} · {value2} · Version {value3}",
    "messageAssigned": "{value1} assigned",
    "messageVersion22": "{value1} · {value2} · Version {value3}",
    "messageFrameworkReferenceFor": "Framework reference for {value1}",
    "messageControlsAssigned": "{value1} Controls assigned",
    "messageSuggestedEvidence": "{value1} · Suggested Evidence: {value2}",
    "messagePrivanaTemplate": "Privana template · {value1} Controls",
    "messageSelected": "{value1} selected",
    "messageVersion": "Version {value1}",
    "messageControls2": "{value1} Controls",
    "messageReviewed": "{value1} / {value2} reviewed",
    "messageVersion23": "{value1} · {value2} · Version {value3}",
    "messageSelected2": "{value1} selected",
    "messageEvidence2": "{value1} · {value2} · Evidence: {value3}",
    "messageSelected3": "{value1} selected",
    "messageVersion3": "Version {value1}",
    "messagePage": "Page {value1} · {value2} records",
    "messageInsuranceIntelligence3": "Insurance Intelligence · {value1}",
    "messageAnalysing": "Analysing {value1}",
    "messageOf": "{value1} · {value2} of {value3} pages processed",
    "messagePage2": "{value1} · page {value2} · View Source",
    "messageOf2": "{value1} of {value2} reviewed · {value3} remaining",
    "messageExistingMatches": "{value1} existing matches · {value2} suggested Controls · {value3} dates · {value4} needs review",
    "messageReview": "Review {value1} →",
    "messageStatus2": "Status: {value1}",
    "messageFrameworks2": "Frameworks: {value1}",
    "messageLatestAssessment": "Latest assessment: {value1}",
    "messageEvidence3": "Evidence: {value1}",
    "messageLibraryProvenance": "Library provenance: {value1} · version {value2} · {value3}",
    "messageTarget": "Target: {value1} · Version {value2}",
    "messagePage3": "Page {value1} · View Source",
    "messageAll": "All {value1} extracted clauses remain available, grouped for easier review.",
    "messageConfidencePage": "{value1}% confidence · page {value2}",
    "messagePage22": "{value1} · page {value2} · View Source",
    "messagePages": "{value1} · {value2} · {value3} pages · {value4}",
    "messageVersion24": "{value1} · Version {value2} · {value3} · {value4} Controls",
    "messageEvaluation2": "Evaluation: {value1} · Evidence: {value2}",
    "messagePrivanaLibrary": "Privana Library · {value1} · Version {value2} · {value3}",
    "messagePage23": "{value1} · page {value2} · View Source",
    "messagePages2": "{value1} pages",
    "messageMappings": "{value1} mappings",
    "messageLatest": "Latest {value1}",
    "messageOverdue3": "{value1} overdue",
    "criticalHigh": "Critical / High",
    "frameworkControl": "Framework / Control",
    "outlookRenewal": "Prepare {title} Renewal",
    "outlookPolicy": "Policy: {title}",
    "outlookInsurer": "Insurer: {name}",
    "outlookNumber": "Policy number: {number}",
    "outlookExpiry": "Expiry: {date}",
    "futureRelease": "This workspace is ready for a future Compliance release."
  },
  "enums": {
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "critical": "Critical",
    "open": "Open",
    "active": "Active",
    "draft": "Draft",
    "retired": "Retired",
    "superseded": "Superseded",
    "withdrawn": "Withdrawn",
    "applicable": "Applicable",
    "not_applicable": "Not Applicable",
    "under_review": "Under Review",
    "in_progress": "In Progress",
    "completed": "Completed",
    "cancelled": "Cancelled",
    "accepted": "Accepted",
    "remediation_in_progress": "Remediation In Progress",
    "ready_for_review": "Ready For Review",
    "closed": "Closed",
    "void": "Void",
    "blocked": "Blocked",
    "compliant": "Compliant",
    "partially_compliant": "Partially Compliant",
    "non_compliant": "Non Compliant",
    "not_evaluated": "Not Evaluated",
    "initial": "Initial",
    "periodic": "Periodic",
    "reassessment": "Reassessment",
    "manual": "Manual",
    "automated": "Automated",
    "integrated": "Integrated",
    "hybrid": "Hybrid",
    "manual_attestation": "Manual Attestation",
    "document": "Document",
    "system_evidence": "System Evidence",
    "integrated_evidence": "Integrated Evidence",
    "sensor_telemetry": "Sensor Telemetry",
    "uploaded_document": "Uploaded Document",
    "privana_safety": "Privana Safety",
    "privana_element": "Privana Element",
    "completed_checklist": "Completed Checklist",
    "risk_assessment": "Risk Assessment",
    "alert_event": "Alert Event",
    "supports": "Supports",
    "contradicts": "Contradicts",
    "remediates": "Remediates",
    "verifies": "Verifies",
    "control": "Control",
    "assessment": "Assessment",
    "finding": "Finding",
    "action": "Action",
    "framework": "Framework",
    "framework_version": "Framework Version",
    "evidence": "Evidence",
    "evidence_link": "Evidence Link",
    "audit_pack": "Audit Pack",
    "generating": "Generating",
    "generated": "Generated",
    "queued": "Queued",
    "processing": "Processing",
    "failed": "Failed",
    "error": "Error",
    "uploaded": "Uploaded",
    "uploading": "Uploading",
    "policy_wording": "Policy Wording",
    "policy_schedule": "Policy Schedule",
    "endorsement": "Endorsement",
    "renewal_terms": "Renewal Terms",
    "supporting_document": "Supporting Document",
    "other": "Other",
    "to_review": "To Review",
    "reviewed": "Reviewed",
    "adopted": "Adopted",
    "dismissed": "Dismissed",
    "exclusion": "Exclusion",
    "condition": "Condition",
    "recommendation": "Recommendation",
    "definition": "Definition",
    "informational": "Informational",
    "coverage": "Coverage",
    "notification_obligation": "Notification Obligation",
    "warranty": "Warranty",
    "obligation": "Obligation",
    "assessmentCoverage": "AssessmentCoverage",
    "findingResolution": "FindingResolution",
    "actionTimeliness": "ActionTimeliness",
    "evidenceCoverage": "EvidenceCoverage",
    "scanned": "Scanned",
    "created": "Created",
    "unchanged": "Unchanged",
    "linked": "Linked",
    "skipped": "Skipped",
    "sourceErrors": "SourceErrors",
    "linkErrors": "LinkErrors",
    "current": "Current",
    "historical": "Historical",
    "pass": "Pass",
    "fail": "Fail",
    "review_due": "Review Due",
    "privana_object_storage": "Privana Object Storage",
    "actions": "Actions",
    "frameworks": "Frameworks",
    "assessments": "Assessments",
    "control_created": "Control Created",
    "control_updated": "Control Updated",
    "control_status_changed": "Control Status Changed",
    "control_version_created": "Control Version Created",
    "framework_created": "Framework Created",
    "framework_version_created": "Framework Version Created",
    "framework_control_linked": "Framework Control Linked",
    "framework_control_unlinked": "Framework Control Unlinked",
    "framework_controls_reconciled": "Framework Controls Reconciled",
    "framework_control_copied": "Framework Control Copied",
    "framework_created_from_library": "Framework Created From Library",
    "control_created_from_library": "Control Created From Library",
    "framework_status_changed": "Framework Status Changed",
    "framework_version_status_changed": "Framework Version Status Changed",
    "framework_applicability_changed": "Framework Applicability Changed",
    "assessment_created": "Assessment Created",
    "assessment_status_changed": "Assessment Status Changed",
    "assessment_results_initialized": "Assessment Results Initialized",
    "assessment_result_recorded": "Assessment Result Recorded",
    "finding_created": "Finding Created",
    "finding_metadata_changed": "Finding Metadata Changed",
    "finding_status_changed": "Finding Status Changed",
    "action_created": "Action Created",
    "action_metadata_changed": "Action Metadata Changed",
    "action_status_changed": "Action Status Changed",
    "evidence_created": "Evidence Created",
    "evidence_document_uploaded": "Evidence Document Uploaded",
    "evidence_metadata_changed": "Evidence Metadata Changed",
    "evidence_status_changed": "Evidence Status Changed",
    "evidence_linked": "Evidence Linked",
    "evidence_unlinked": "Evidence Unlinked",
    "evidence_source_mapping_created": "Evidence Source Mapping Created",
    "evidence_source_mapping_changed": "Evidence Source Mapping Changed",
    "evidence_source_mapping_disabled": "Evidence Source Mapping Disabled",
    "trusted_evidence_created": "Trusted Evidence Created",
    "integrated_evidence_superseded": "Integrated Evidence Superseded",
    "audit_pack_created": "Audit Pack Created",
    "audit_pack_generated": "Audit Pack Generated",
    "audit_pack_voided": "Audit Pack Voided",
    "controls": "Controls",
    "findings": "Findings",
    "evidence_records": "Evidence Records",
    "current_evidence": "Current Evidence",
    "current_documents_included": "Current Documents Included",
    "suggested": "Suggested",
    "confirmed": "Confirmed",
    "insurance": "Insurance",
    "insurance_policy": "Insurance Policy",
    "insurance_document": "Insurance Document",
    "insurance_date": "Insurance Date",
    "insurance_analysis": "Insurance Analysis",
    "insurance_document_uploaded": "Insurance Document Uploaded",
    "insurance_analysis_started": "Insurance Analysis Started",
    "insurance_calendar_event_added": "Insurance Calendar Event Added",
    "preparing": "Preparing",
    "validating": "Validating",
    "evidence_source_mapping": "Evidence Source Mapping",
    "verified": "Verified",
    "partial": "Partial",
    "not_started": "Not Started"
  },
  "controlValues": {
    "importance": {
      "low": "Low",
      "medium": "Medium",
      "high": "High",
      "critical": "Critical"
    },
    "evaluationMethod": {
      "manual": "Manual review",
      "automated": "Automated review",
      "integrated": "Integrated review",
      "hybrid": "Hybrid review"
    },
    "evidenceMethod": {
      "manual_attestation": "Manual attestation",
      "document": "Document review",
      "system_evidence": "System evidence",
      "integrated_evidence": "Integrated evidence",
      "sensor_telemetry": "Sensor telemetry",
      "hybrid": "Hybrid evidence"
    }
  },
  "assurance": {
    "Not Assessed": "Not Assessed",
    "At Risk": "At Risk",
    "Attention Needed": "Attention Needed",
    "Strong": "Strong"
  },
  "report": {
    "title": "Audit Pack",
    "brand": "PRIVANA COMPLIANCE",
    "generated": "Generated {date}\nClub timezone: {timezone}\nIntegrity SHA-256: {hash}",
    "executive": "Executive Summary",
    "summary": "{assessment} against {framework} {version}. Controls: {controls}; findings: {findings}; actions: {actions}; evidence records: {evidence}.",
    "frameworkAssessment": "Framework & Assessment",
    "scope": "Framework: {key} — {framework}\nVersion: {version} ({status})\nEffective dates: {from} to {to}\nAssessment: {assessment} ({type})\nStarted: {started}\nCompleted: {completed}",
    "openEnded": "open ended",
    "controlResults": "Control Results",
    "noNarrative": "No narrative",
    "evaluated": " · Evaluated {date}",
    "findings": "Findings",
    "closed": " · Closed {date}",
    "noFindings": "No findings recorded.",
    "actions": "Remediation Actions",
    "due": "Due {date}",
    "completed": " · Completed {date}",
    "noActions": "No remediation actions recorded.",
    "evidence": "Evidence Register",
    "noEvidence": "No evidence recorded.",
    "audit": "Audit Trail",
    "integrity": "Generation / Integrity Information",
    "integrityText": "Manifest format: {version}\nHash convention: SHA-256 of canonical JSON payload excluding the integrity member.\nManifest hash: {hash}\nThis is an immutable historical snapshot, not a regulatory certification.",
    "page": "Privana · {key} · Page {page} of {total}"
  },
  "warnings": {
    "non_compliant": "Assessment has Non-Compliant results",
    "open_findings": "Open Findings remain",
    "findings_review": "Findings are Ready for Review",
    "withdrawn_evidence": "Withdrawn Evidence is linked to scope",
    "missing_evidence": "Relevant Controls have no Active positive Evidence"
  }
};
